/*
 * Live Builder cart sync (Trend Printing)
 * Personalization fees are separate cart lines tagged with _lb_fee and a
 * _builder_id that matches their sweatshirt. This keeps them honest:
 *  - sweatshirt removed  -> its fees are removed
 *  - sweatshirt qty 3    -> its fees go to qty 3
 *  - fee qty changed     -> put back to match the sweatshirt
 *  - per-item fees (icons) carry _lb_mult, e.g. 3 icons per sweatshirt
 * Load it on every page from layout/theme.liquid.
 */
(() => {
  if (window.__lbCartSync) return;
  window.__lbCartSync = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const nativeFetch = window.fetch.bind(window);
  let running = false;
  let queued = false;

  async function sync() {
    if (running) {
      queued = true;
      return;
    }
    running = true;
    try {
      const cart = await nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const mainQty = {};
      for (const item of cart.items) {
        const p = item.properties || {};
        if (p._builder_id && !p._lb_fee) mainQty[p._builder_id] = (mainQty[p._builder_id] || 0) + item.quantity;
      }
      const updates = {};
      let changed = false;
      for (const item of cart.items) {
        const p = item.properties || {};
        if (!p._lb_fee || !p._builder_id) continue;
        const mult = Math.max(1, parseInt(p._lb_mult, 10) || 1);
        const want = (mainQty[p._builder_id] || 0) * mult;
        if (item.quantity !== want) {
          updates[item.key] = want;
          changed = true;
        }
      }
      if (changed) {
        await nativeFetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates }),
        });
        // refresh so the cart page / drawer shows the corrected lines and totals
        window.location.reload();
        return;
      }
    } catch (e) {
      console.warn('[lb-cart-sync]', e);
    } finally {
      running = false;
      if (queued) {
        queued = false;
        setTimeout(sync, 200);
      }
    }
  }

  // run whenever the theme changes the cart
  window.fetch = function (input, init) {
    const p = nativeFetch(input, init);
    try {
      const url = typeof input === 'string' ? input : input && input.url;
      if (url && /\/cart\/(change|update)(\.js)?(\?|$)/.test(url)) {
        p.then(() => setTimeout(sync, 250)).catch(() => {});
      }
    } catch (e) {}
    return p;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();

  // coming back to a tab where the cart may have changed elsewhere
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') sync();
  });
})();
